const envElement = document.getElementById('env');
const environment = envElement ? envElement.dataset.env : 'unknown';

const appSettings = {
  debug: true,
  environment,
};

export { appSettings };